module.exports = __webpack_public_path__ + "img/warning.40292ddf.png";